import { Models } from '$models';
import { PropertyDisclosuresService } from '$services';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { TermsAgreeViewType } from 'src/app/components/terms-of-service-parts/agree-terms/agree-terms.component';
import { AgentTermsComponent } from '../../../../terms-of-service-parts/agent-terms/agent-terms.component';
import { AgreeTermsComponent } from '../../../../terms-of-service-parts/agree-terms/agree-terms.component';
import { CounterBidDisclosureComponent } from '../../../../terms-of-service-parts/counter-bid-disclosure/counter-bid-disclosure.component';
import { InvestorTermsComponent } from '../../../../terms-of-service-parts/investor-terms/investor-terms.component';
import { UserTermsOhioComponent } from '../../../../terms-of-service-parts/user-terms-ohio/user-terms-ohio.component';
import { UserTermsComponent } from '../../../../terms-of-service-parts/user-terms/user-terms.component';
import { BiddingService } from '../../shared/services/bidding.service';

@Component({
  selector: 'app-bid-terms-of-service',
  templateUrl: './bid-terms-of-service.component.html',
  styleUrls: ['./bid-terms-of-service.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PropertyDisclosuresService],

  imports: [UserTermsComponent, AgreeTermsComponent, InvestorTermsComponent, AgentTermsComponent, UserTermsOhioComponent, CounterBidDisclosureComponent, AsyncPipe],
})
export class BidTermsOfServiceComponent implements OnChanges {
  private disclosures = inject(PropertyDisclosuresService);

  @Input() user: Models.LoginResponse | null = null;
  @Input() property: Models.PropertyDetailsResponse | null = null;

  TermsAgreeViewType = TermsAgreeViewType;
  disclosures$ = this.disclosures.disclosures$.asObservable();

  get isUserAgent(): boolean {
    return BiddingService.isUserAgent(this.user);
  }

  get isUserBidder(): boolean {
    return BiddingService.isUserBidder(this.user);
  }

  get isUserInvestor(): boolean {
    return BiddingService.isUserInvestor(this.user);
  }

  get isOhio(): boolean {
    return BiddingService.isOhio(this.property);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['property'] && this.property) {
      this.disclosures.fetchAll(this.property.ITEM_ID);
    }
  }
}
